import { request } from "@/utils/remoteRequest";

export function getDepartmentByDeptCode(data) {
  return request({
    url: "/orgManage/searchDepartmentByDeptCode",
    method: "post",
    data,
  });
}

export function saveRemark(data) {
  return request({
    url: "/orgManage/saveRemark",
    method: "post",
    data,
  });
}
